export default __webpack_public_path__ + "static/media/sch8_w320.93b63a0b.jpg";